import React, { Component } from 'react';

import { Range } from 'rc-slider';

import TimeControl from './TimeControl';
import { secondsToString } from './TimeUtils';

if (typeof window !== 'undefined') {
  require('rc-slider/assets/index.css');
}

export default class ClipControls extends Component {
  constructor() {
    super();
    this.state = {
      focus: false,
      tooLong: false,
    };
    this.setState = this.setState.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.refs.clipStart) {
      this.refs.clipStart.set(secondsToString(nextProps.clipStart));
    }
    if (this.refs.clipEnd) {
      this.refs.clipEnd.set(secondsToString(nextProps.clipEnd));
    }
  }

  render() {
    const self = this;

    return (
      <div>
        <div id="clip-controls-slider">
          <Range
            ref="range"
            max={self.props.duration}
            className={`clip-slider-control ${
              this.props.tooLong ? 'error' : ''
            }`}
            value={[self.props.clipStart, self.props.clipEnd]}
            count={2}
            step={0.01}
            onChange={(value) => {
              if (self.refs.clipStart) {
                self.refs.clipStart.blur();
              }
              if (self.refs.clipEnd) {
                self.refs.clipEnd.blur();
              }

              if (value[1] - value[0] < 0.1) {
                return;
              }

              if (value[0] !== self.props.clipStart) {
                if (self.refs.clipStart) {
                  self.refs.clipStart.set(secondsToString(value[0]));
                }
                self.props.onStartChange(value[0]);
              } else if (value[1] !== self.props.clipEnd) {
                if (self.refs.clipEnd) {
                  self.refs.clipEnd.set(secondsToString(value[1]));
                }
                self.props.onEndChange(value[1]);
              }
            }}
            onAfterChange={() => {
              self.props.onAfterChange();
              setTimeout(() => {
                self.setState({ scrubbing: false });
              }, 1000);
            }}
            onBeforeChange={() => {
              this.setState({ scrubbing: true });
            }}
          />
          {!this.props.mobile ? (
            <div
              className="slider-caret-container"
              ref="caretContainer"
              onMouseDown={(e) => {
                const startTime =
                  (e.nativeEvent.offsetX /
                    this.refs.caretContainer.offsetWidth) *
                  this.props.duration;
                this.props.onScrubStart(startTime);

                const offsetX = e.nativeEvent.offsetX;
                const mouseMove = (moveEvent) => {
                  const moveX = moveEvent.offsetX - offsetX;
                  let time =
                    (moveX / this.refs.caretContainer.offsetWidth) *
                      this.props.duration +
                    startTime;
                  if (time > this.props.clipEnd) {
                    time = this.props.clipEnd;
                  } else if (time < this.props.clipStart) {
                    time = this.props.clipStart;
                  }

                  this.props.onScrub(time);
                };
                const mouseUp = () => {
                  document.removeEventListener('mousemove', mouseMove);
                  document.removeEventListener('mouseup', mouseUp);
                  this.props.onScrubEnd();
                };
                document.addEventListener('mousemove', mouseMove);
                document.addEventListener('mouseup', mouseUp);
              }}
            >
              <div
                className="slider-caret"
                ref="caret"
                style={{
                  visibility: this.state.scrubbing ? 'hidden' : 'visible',
                }}
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <div id="clip-controls-time">
          <TimeControl
            onChange={(v, f) => {
              this.props.onStartChange(v, f);
              this.setState({
                focus: !f,
              });
            }}
            value={this.props.clipStart}
            ref="clipStart"
            name="Start"
            {...this.props}
          />
          <span className="clip-controls-time-separator">to</span>
          <TimeControl
            onChange={(v, f) => {
              this.props.onEndChange(v, f);
              this.setState({
                focus: !f,
              });
            }}
            value={this.props.clipEnd}
            ref="clipEnd"
            name="End"
            {...this.props}
          />
          {!this.props.mobile && this.state.focus ? (
            <div className="clip-control-help">
              Tip:&nbsp;&nbsp;Use the arrow keys for fine adjustment.
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}
